import React from "react";
import { FaRegHandPointer } from "react-icons/fa";

export const PriKPI = ({
  Image,
  Alt,
  ColorDark,
  Title,
  Value,
  Padding,
  ImageSize,
  onclick,
  subtext,
  handPosition,
}) => {
  const content = (
    <div
      className={`grid grid-cols-[auto_1fr] ${Padding} text-white rounded-lg ${ColorDark} mt-2 md:mt-0`}
      title={Alt}
    >
      <div className={`flex flex-col`}>
        <img
          src={Image}
          alt={Alt}
          className={`self-center ${ImageSize} justify-self-center`}
        />
        {subtext && <span className="text-[11px] text-center ">{subtext}</span>}
      </div>
      <div className="grid items-center justify-center relative">
        {onclick && (
          <div
            className={`flex justify-center items-center absolute  ${handPosition}`}
          >
            <button className="relative p-1 text-white bg-[#e03f3f] rounded-full hover:bg-blue-600 focus:outline-none group">
              <span className="text-xs text-white">
                <FaRegHandPointer />
              </span>
              <span className="absolute inset-0 rounded-full bg-sky-400 opacity-75 blur-md animate-ping"></span>
            </button>
          </div>
        )}

        <div className="text-sm font-semibold text-center whitespace-nowrap">
          {Title}
        </div>
        <div className="text-3xl font-bold md:text-xl lg:text-3xl justify-self-center leading-5">
          {Value}
        </div>
      </div>
    </div>
  );

  if (onclick) {
    return (
      <div
        onClick={onclick}
        className="no-underline transition duration-300 ease-in-out transform hover:scale-105"
        title="Click here to View Detailed Summary"
      >
        {content}
      </div>
    );
  } else {
    return content;
  }
};
